// Import images for use in the data
import imgSeedsAfghanistanHero from "../assets/imgSeedsPresentation.jpg";
import imgSeedsAfghanistanWebsite from "../assets/Seeds-Website.jpg";
import imgSeedsAfghanistan from "../assets/Seed-Mapping.png";
import imgSeedsAfghanistanStructure from "../assets/Seed-Structure.png";
import imgCVJungleHero from "../assets/imgCVJungleHero.jpg";
import imgCVJungleDashboard from "../assets/imgCVJungleDashboard.jpg";
import imgCVJungleBranding from "../assets/imgCVJungleBranding.jpg";
import imgCVJungleWebsite from "../assets/imgCVJungleWebsite.png";  
import imgLaIslaJuiceBar from "../assets/La Isla - Juice Bar.jpg";
import imgLaIslaJuiceBar2 from "../assets/La Isla - Juice Bar.jpg";
import imgLaIslaJuiceBarlogo from "../assets/La Isla - Juice Bar Logo.jpg";
import imgAdwumaYeWebsite from "../assets/Adwumaye Website.png";
import imgAdwumaYewireframe from "../assets/AdwumaYewireframe.png";
import imgAdwumaYewireframe2 from "../assets/Adwumayewriframe2.png";
import imgAdwumaYeHero from "../assets/Adwumaye hero.png";
import imgSunshineBooksHero from "../assets/Sunshinehero.jpg";
import imgSunshineBooksDashboard from "../assets/Sunshinedashboard.jpg";
import imgSunshineBooksDetails from "../assets/Sunshinedashboard2.jpg";

import imgCrocsChristianCowanHero from "../assets/Crocs Website.jpg";
import imgCrocsChristianCowanwireframe from "../assets/CROCS wireframe.jpg";
import imgCrocsChristianCowanwireframe2 from "../assets/CROCS wireframe2.jpg";
import imgCrocsChristianCowanCredits from "../assets/Crocs credits.png";

import imgAnalyticos from "../assets/892f22a579ad77bf6804f37ba7329577aa64142e.png";

import imgExperienceFoundry from "../assets/cf6b7fe96c6b8c467f8bce6e3ce2e6482dcb048c.png";

export interface ProjectDetails {
  id: string;
  slug: string;
  title: string;
  subtitle: string;
  principalrole: string;
  role: string[];
  scope: string;
  direction: string; // e.g. URL
  process: {
    title: string;
    description: string;
  }[];
  gallery: {
    url: string;
    alt: string;
    caption?: string;
  }[];
  heroImage: string;
  description: string;
  featured?: boolean;
}

export const projectsData: ProjectDetails[] = [
  {
    id: "Seeds Afghanistan",
    slug: "Seeds-Afghanistan",
    featured: true,
    title: "Seeds Afghanistan",
    subtitle: "Empowering Afghan communities through sustainable agriculture",
    principalrole: "UX/UI Designer",
    role: ["UX/UI Designer", "Frontend Developer"],
    scope: "Website Redesign",
    direction: "https://seedsafghanistan.org",
    heroImage: imgSeedsAfghanistanHero,
    description: "Redesigning the Seeds Afghanistan website to better communicate their mission and impact, while improving user experience for donors and stakeholders.",
    process: [
      { title: "UX Process", description: "This was a beautifully straightforward process , the team at Seeds came with clear intentions, a strong message, and content ready to go. My role was to give structure and elevate their story through thoughtful UX and visual design." },
      { title: "Sitemap Design", description: "The content was already developed, I translated it into an intuitive sitemap that prioritized:\n• Clear messaging hierarchy\n• Simple navigation with minimal distractions\n• Storytelling flow: **Mission → Programs → Impact → Get Involved**" },
      { title: "Benchmarking & Design Proposals", description: "After the sitemap was approved, I moved into visual research and mood boarding. I benchmarked similar humanitarian and NGO websites to ensure the site:\n• Felt trustworthy and authentic\n• Respected Afghan cultural elements subtly\n• Worked well across mobile, tablet, and desktop" },
      { title: "Responsive Development", description: "Mobile-first mindset! I ensured the design scaled gracefully on all devices, maintaining readability and ease of navigation." }
    ],
    gallery: [
      { url: imgSeedsAfghanistanHero, alt: "Seeds Afghanistan" },
      { url: imgSeedsAfghanistanWebsite, alt: "Seeds Afghanistan" },
      { url: imgSeedsAfghanistan, alt: "Seeds Afghanistan" },
      { url: imgSeedsAfghanistanStructure, alt: "Seeds Afghanistan Structure" }
    ]
  },
  {
    id: "CVJungle",
    slug: "cvjungle",
    featured: true,
    title: "CVJungle",
    subtitle: "Streamlining recruitment in Latin America",
    principalrole: "Brand Designer",
    role: ["Brand Designer", "UX/UI Designer"],
    scope: "Branding and Website",
    direction: "https://www.crunchbase.com/organization/cvjungle-com",
    heroImage: imgCVJungleHero,
    description: "Platform Design & Branding for a Guatemalan SaaS startup that provides a comprehensive solution for financial management and analysis. The project involved creating a cohesive brand identity and designing an intuitive user interface for their web application.",
    process: [
      { title: "Discovery & Vision Alignment", description: "We began the project with a series of vision-mapping sessions with the founding team. The goal was to clearly define the platform’s purpose: to simplify how companies find candidates for low- and mid-level roles, while offering tools for better hiring decisions through data. During this phase, I gathered insights about the audience—both job seekers and recruiters—and translated them into design and communication goals." },
      { title: "UX/UI & Product Design Strategy", description: "Using a lean, iterative approach, I designed the first version of the platform focusing on clarity and ease of use. Key steps included: \n•Wireframing core flows for candidates (resume creation, profile setup) and companies (search filters, candidate comparison). \n• Prioritizing features that solved real problems—such as fast profile filtering and visual resume stats.Prototyping and testing user flows internally before development. \n• Designing responsive layouts for both desktop and mobile." },
      { title: "Brand Positioning & Identity Design", description: "The startup needed a strong visual identity that felt modern, trustworthy, and professional. I led the brand development process by:\n• Researching industry trends and competitors.\n• Sketching logo concepts based on keywords like \n\"growth,\" \"connection,\" and \"clarity.\" Creating moodboards to capture tone and style direction.\n• Designing a scalable logo and selecting a clean, accessible font pairing.\n• Developing brand guidelines covering color palettes, logo usage, and visual tone." },
      {title:"Visual Consistency Across Channels", description:"To ensure a cohesive experience, I created a complete **visual language system**: icons, infographics, color schemes, and UI components that aligned across the website, ads, and pitch materials."},
      {title:"Marketing Asset Creation",description:"To support early-stage user acquisition, I designed:\n• Social media graphics with recruitment tips and platform features.\n•  Ad banners for use on local job boards and news outlets.\n• Email templates for onboarding and candidate matches.\n• Presentation decks for investor and client pitches."},
      {title:"Collaboration & Agile Workflow",description:"Throughout the project, I worked closely with developers to align on design specs and deliver pixel-perfect assets. I also collaborated with our marketer to test different messaging strategies, ensuring that design supported business goals at every stage."}
    ],
    gallery: [
      { url: imgCVJungleHero, alt: "CVJungle Hero" },
      { url: imgCVJungleDashboard, alt: "CVJungle Dashboard Mockup" },
      { url: imgCVJungleBranding, alt: "CVJungle Branding" },
      { url: imgCVJungleWebsite, alt: "CVJungle Website" }
    ]
  },
  {
    id: "la-isla-juice-bar",
    slug: "la-isla-juice-bar",
    featured: true,
    title: "La Isla - Juice Bar",
    subtitle: "Refreshing flavors for a vibrant community",
    principalrole: "Brand Designer",
    role: ["Brand Designer"],
    scope: "Brand Identity",
    direction: "No website available",
    heroImage: imgLaIslaJuiceBar,
    description: "While working at 360 Graphic Studio, a full-service advertising agency, I was assigned to develop the brand identity for La Isla, a juice bar located in Belgium. The project began with a simple sketch provided by the client, which I transformed into a vibrant and cohesive visual identity that captured the essence of the brand.",
    process: [
       { title: "Research & Mood boarding", description: "I explored tropical motifs, fresh color palettes, fruit symbolism, and friendly typefaces. Inspiration was drawn from natural textures, juicy fruits, and playful shapes." },
       { title: "Concept Sketches & Logo Exploration", description: "Based on the client’s original drawing, I developed logo concepts that balanced modern design with hand-drawn charm. I played with rounded typography and island-inspired iconography." },
       { title:"Color & Typography", description:"I selected a bright, warm color palette—think mango, lime, and ocean blue—paired with a bold, rounded sans-serif font for readability and fun."},
       { title:" Brand Identity System ", description:"The final brand package included:\n• Primary and secondary logos. Icon set and illustrations.\n• Color and typography system.\n• Print and digital mockups.\n• Social media templates"}
    ],
    gallery: [
      { url: imgLaIslaJuiceBar, alt: "Moodtalk Homepage" },
      { url: imgLaIslaJuiceBar2, alt: "Moodtalk Homepage" },
      { url: imgLaIslaJuiceBarlogo, alt: "Moodtalk App Interface" }
    ]
  },
  {
    id: "crocs-x-christian-cowan",
    slug: "crocs-x-christian-cowan",
    featured: true,
    title: "Crocs x Christian Cowan",
    subtitle: "A bold digital experience for a high-fashion collaboration",
    principalrole: "UX Designer",
    role: ["UX Designer"],
    scope: "UX Design, Wireframing",
    direction: "https://www.instagram.com/p/CjD2WJ0J4hQ/?hl=en",
    heroImage: imgCrocsChristianCowanHero,
    description: "To celebrate Crocs’ bold new partnership with British designer Christian Cowan, We Are Social Amsterdam led a digital-first campaign to launch the limited edition collection. The goal was to craft an immersive, fashion-forward e-commerce experience that would translate Cowan’s avant-garde aesthetic into a fun, fearless and seamless shopping journey.",
    process: [
      { title: "UX Audit", description: "I started with a comprehensive analysis of Crocs’ existing digital presence and customer journey. The audit helped us identify friction points and areas to elevate visual storytelling and engagement." },
      { title: "Wireframing", description: "I created mobile-first wireframes focused on intuitive navigation, modular storytelling, and rapid access to shop categories." },
      { title:"UI Assistance", description:"I supported the Art Director by transforming wireframes into high-fidelity mockups, ensuring consistency with Crocs’ design system and Cowan’s high-fashion tone."},
      { title:"Accessibility & Responsiveness: ", description:"I helped optimize the layouts to be accessible and fully responsive across devices, integrating WCAG principles and usability best practices."}
    ],
    gallery: [
      { url: imgCrocsChristianCowanHero, alt: "Crocs x Christian Cowan Hero Image" },
      { url: imgCrocsChristianCowanwireframe, alt: "Crocs x Christian Cowan Wireframe" },
      { url: imgCrocsChristianCowanwireframe2, alt: "Crocs x Christian Cowan Wireframe" },
      { url: imgCrocsChristianCowanCredits, alt: "Crocs x Christian Cowan Credits" }
    ]
  },
  {
      id: "Adwuma Ye Website",
      slug: "adwuma-ye-website",
      featured: true,
      title: "Adwuma Ye Website",
      subtitle: "Empowering communities through a user-centered NGO website",
      principalrole: "Web Designer",
      role: ["Web Designer", "UX/UI Designer"],
      scope: "Website Design, UX Design",
      direction: "https://www.figma.com/proto/m1l5bTi3cp07lfzemyhStS/UX-Design-Case-Study-Presentation-Adyuma-Ye?node-id=2-4&t=C9tBV09PAqjApNlP-0&scaling=contain&content-scaling=fixed&page-id=0%3A1",
      heroImage: imgAdwumaYeHero,
      description: "A clean, fresh e-commerce experience for a natural teeth whitening brand.",
      process: [
        { title: "The Problem", description: "The user faces difficulty comprehending key aspects of the NGO website, including who are the beneficiaries, how to use the New Cooking Bag and benefits of it, donation impact, and other products and organization achievements." },
        { title: "The Goal", description: "Create an inclusive website design allowing users to easily donate or purchase products." },
        { title:"Understanding the user", description:"Primary pain points: \n **1 -Understanding who are the beneficiaries of the NGO.** \n **2 -NCB Usage Confusion.** \n **3 -Information Gap on Donation Utilization and Achievements**"},
        { title:"User journey map", description:"We track our user persona's journey through three stages: learning about NCB, encountering an Adwuma Ye Instagram (paid) story, and reading an article about Adwuma Ye. Eventually, she either purchases our new cooking bag or donates to our NGO."},
        { title:"Design Solutions", description:"To address the pain points, we implemented the following design solutions: \n **1 - Clear Beneficiary Information:** We added a dedicated section on the homepage that highlights the beneficiaries of our NGO, including their stories and how donations make an impact. \n **2 - Simplified NCB Usage Instructions:** We created a step-by-step guide with visuals to explain how to use the New Cooking Bag effectively. \n **3 - Transparent Donation Impact:** We included a section that shows how donations are utilized, along with our achievements and milestones to build trust and encourage contributions."},
        { title:"Outcome", description:"The redesigned website provides a clear and engaging user experience, making it easier for visitors to understand our mission, use our products, and contribute to our cause."}
      ],
      gallery: [
        { url: imgAdwumaYeHero, alt: "Adwuma Ye Desktop View" },
        { url: imgAdwumaYewireframe, alt: "Adwuma Ye Wireframe" },
        { url: imgAdwumaYewireframe2, alt: "Adwuma Ye Wireframe" },
        {url: imgAdwumaYeWebsite, alt: "Adwuma Ye Wireframe" }
      ]
  },
  {
    id: "Sunshine Books",
    slug: "sunshine-books",
    featured: true,
    title: "Sunshine Books",
    subtitle: "A Modern Book Discovery Platform",
    principalrole: "UI/UX Design",
    role: ["UI/UX Design", "Web Development"],
    scope: "Website Design, User Experience Design",
    direction: "https://sunshinebooks.netlify.app/",
    heroImage: imgSunshineBooksHero,
    description: "Sunshine Books is a sleek and user-friendly web application designed to help users discover and explore books effortlessly. Sunshine Books is a testament to my skills in React.js development, UI/UX design, and front-end performance optimization.",
    process: [
      { title: "Tech Stack", description: "Frontend Framework: React.js (with Vite). \n Database: Firebase Realtime Database\n Styling: Tailwind CSS\n\nTools: Figma, Firebase Console, Postman (for testing)" },
      { title: "Key Features", description: " Dynamic Book Search. \n Users can browse and search for books based on various criteria.\n Modern UI & Responsive Design.\n Built with Tailwind CSS, ensuring a smooth experience across devices. \n Efficient State Management. \n Optimized for performance with React’s state handling.\n API Integration. \n Fetches real-time book data from an external API.​​​​​​​" }
    ],
    gallery: [
      { url: imgSunshineBooksHero, alt: "Sunshine Books Hero" },
      { url: imgSunshineBooksDashboard, alt: "Sunshine Books Dashboard" },
      { url: imgSunshineBooksDetails, alt: "Sunshine Books Book Details" },
    ]
  },
   {
      id: "experience-foundry",
      slug: "experience-foundry",
      title: "Experience Foundry",
      subtitle: "Digital transformation agency",
      principalrole: "Web Design",
      role: ["Web Design"],
      scope: "Agency Website",
      direction: "https://expfoundry.com",
      heroImage: imgExperienceFoundry,
      description: "A professional and sleek website for a digital transformation consultancy.",
      process: [
        { title: "Strategy", description: "Defining the agency's value proposition." },
        { title: "Design", description: "Creating a high-end corporate aesthetic." }
      ],
      gallery: [
        { url: imgExperienceFoundry, alt: "Homepage Hero Section" }
      ]
   },
    {
      id: "analyticos",
      slug: "analyticos",
      title: "Analyticos",
      subtitle: "Data analytics platform",
      principalrole: "UI Design",
      role: ["UI Design"],
      scope: "Web Application",
      direction: "Internal Tool",
      heroImage: imgAnalyticos,
      description: "An intuitive dashboard for visualizing complex data sets.",
      process: [
        { title: "Information Architecture", description: "Organizing data for clarity." },
        { title: "Dashboard Design", description: "Designing widgets and data visualizations." }
      ],
      gallery: [
        { url: imgAnalyticos, alt: "Dashboard View" }
      ]
   }
];

export function getProjectBySlug(slug: string): ProjectDetails | undefined {
  return projectsData.find(project => project.slug === slug);
}
